<table
  mat-table
  [dataSource]="response.dataSource.data.result"
  class="mat-elevation-z8"
>
  <ng-container *ngFor="let item of response.displayedReference; let i = index">
    <ng-container
      [matColumnDef]="item"
      [stickyEnd]="
        item === 'actions' ||
        item === 'takerActions' ||
        item === 'cgg-tomador' ||
        item === 'insuredActions' ||
        item === 'commercialStructureActions' ||
        item === 'user' ||
        item === 'auditoriaActions'
      "
    >
      <th mat-header-cell *matHeaderCellDef #itemCol>
        {{ response.nameHeader[i] }}
      </th>

      <ng-container *ngIf="item === 'description'">
        <td
          mat-cell
          *matCellDef="let element"
          #itemCol
          [matTooltip]="element[item]"
          [matTooltipDisabled]="element[item]?.length <= 50"
        >
          {{
            element[item]?.length > 50
              ? (element[item] | slice : 0 : 50) + "..."
              : element[item]
          }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'name'">
        <td
          mat-cell
          *matCellDef="let element"
          #itemCol
          [matTooltip]="element[item]"
          [matTooltipDisabled]="element[item]?.length <= 50"
        >
          {{
            element[item]?.length > 50
              ? (element[item] | slice : 0 : 50) + "..."
              : element[item]
          }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'func'">
        <td
          mat-cell
          *matCellDef="let element"
          #itemCol
          [matTooltip]="element[item]"
          [matTooltipDisabled]="element[item]?.length <= 50"
        >
          {{
            element[item]?.length > 50
              ? (element[item] | slice : 0 : 50) + "..."
              : element[item]
          }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'userAuditoria'">
        <td
          mat-cell
          *matCellDef="let element"
          #itemCol
          [matTooltip]="element[item]"
          [matTooltipDisabled]="element[item]?.length <= 50"
        >
          {{
            element[item]?.length > 50
              ? (element[item] | slice : 0 : 50) + "..."
              : element[item]
          }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'insuredsName'">
        <td
          mat-cell
          *matCellDef="let element"
          #itemCol
          [matTooltip]="element[item]"
          [matTooltipDisabled]="element[item]?.length <= 50"
        >
          {{
            element[item]?.length > 50
              ? (element[item] | slice : 0 : 50) + "..."
              : element[item]
          }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'produto'">
        <td
          mat-cell
          *matCellDef="let element"
          #itemCol
          [matTooltip]="element[item]"
          [matTooltipDisabled]="element[item]?.length <= 50"
        >
          {{
            element[item]?.length > 50
              ? (element[item] | slice : 0 : 50) + "..."
              : element[item]
          }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'cobertura'">
        <td
          mat-cell
          *matCellDef="let element"
          #itemCol
          [matTooltip]="element[item]"
          [matTooltipDisabled]="element[item]?.length <= 50"
        >
          {{
            element[item]?.length > 50
              ? (element[item] | slice : 0 : 50) + "..."
              : element[item]
          }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'tomadores'">
        <td
          mat-cell
          *matCellDef="let element"
          #itemCol
          [matTooltip]="element[item]"
          [matTooltipDisabled]="element[item]?.length <= 50"
        >
          {{
            element[item]?.length > 50
              ? (element[item] | slice : 0 : 50) + "..."
              : element[item]
          }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'corretoras'">
        <td
          mat-cell
          *matCellDef="let element"
          #itemCol
          [matTooltip]="element[item]"
          [matTooltipDisabled]="element[item]?.length <= 50"
        >
          {{
            element[item]?.length > 50
              ? (element[item] | slice : 0 : 50) + "..."
              : element[item]
          }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'ratings'">
        <td
          mat-cell
          *matCellDef="let element"
          #itemCol
          [matTooltip]="element[item]"
          [matTooltipDisabled]="element[item]?.length <= 50"
        >
          {{
            element[item]?.length > 50
              ? (element[item] | slice : 0 : 50) + "..."
              : element[item]
          }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'segmentacoesCliente'">
        <td mat-cell *matCellDef="let element" #itemCol class="pdcolumnvalue">
          {{ element[item] }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'maxAdiantamento'">
        <td
          mat-cell
          *matCellDef="let element"
          #itemCol
          [matTooltip]="element[item]"
          [matTooltipDisabled]="element[item]?.toString().length <= 50"
        >
          {{
            element[item]?.toString().length > 50
              ? (element[item] | slice : 0 : 50) + "..."
              : element[item]
          }}%
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'valorMaximoIs'">
        <td mat-cell *matCellDef="let element" #itemCol class="pdcolumnvalue">
          {{ element[item] | currency : "R$" }}
        </td>
      </ng-container>

      <ng-container
        *ngIf="
          item !== 'status' &&
          item !== 'actions' &&
          item !== 'statusCCG' &&
          response.typeData[i] === 'string'
        "
      >
        <td
          mat-cell
          *matCellDef="let element"
          #itemCol
          [matTooltip]="element[item]"
          [matTooltipDisabled]="element[item]?.length <= 50"
        >
          {{
            element[item]?.length > 50
              ? (element[item] | slice : 0 : 50) + "..."
              : element[item]
          }}
        </td>
      </ng-container>

      <ng-container
        *ngIf="
          (item !== 'status' &&
            item !== 'actions' &&
            item !== 'statusCCG' &&
            item === 'minGrievance') ||
          item === 'maxGrievance' ||
          item === 'minDiscount' ||
          item === 'maxDiscount'
        "
      >
        <td mat-cell *matCellDef="let element" #itemCol class="pdcolumnmx">
          {{ element[item] | avaregeFormat : element.averageMixContentId }}
        </td>
      </ng-container>

      <ng-container
        *ngIf="
          item !== 'status' &&
          item !== 'actions' &&
          item !== 'statusCCG' &&
          response.typeData[i] === 'decimal'
        "
      >
        <td mat-cell *matCellDef="let element" #itemCol class="pdcolumnmx">
          {{ element[item] | currency : "R$" }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'textoObjetoSegurado'">
        <td mat-cell *matCellDef="let element" #itemCol class="pdcolumnvalue">
          {{
            element[item]?.length > 50
              ? (element[item] | slice : 0 : 50) + "..."
              : element[item]
          }}
        </td>
      </ng-container>

      <ng-container
        *ngIf="
          item !== 'status' &&
          item !== 'actions' &&
          item !== 'statusCCG' &&
          response.typeData[i] === 'date'
        "
      >
        <td mat-cell *matCellDef="let element" #itemCol class="pdcolumnmx">
          {{ element[item] | date : "dd/MM/yyyy" }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'statusCCG'">
        <td
          mat-cell
          *matCellDef="let element"
          #itemCol
          [ngClass]="
            element.statusCCGId === 1
              ? 'td__status-pendente pdcolumnmx'
              : '' || element.statusCCGId === 2
              ? 'td__status-em-processo pdcolumnmx'
              : '' || element.statusCCGId === 3
              ? 'td__status-aprovado pdcolumnmx'
              : ''
          "
        >
          {{ element.statusCCG }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'textoObjetoSegurado'">
        <td mat-cell *matCellDef="let element" #itemCol class="pdcolumnvalue">
          {{
            element[item]?.length > 50
              ? (element[item] | slice : 0 : 50) + "..."
              : element[item]
          }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'nmProduto'">
        <td
          mat-cell
          *matCellDef="let element"
          #itemCol
          [matTooltip]="element[item]"
          [matTooltipDisabled]="element[item]?.length <= 50"
        >
          {{
            element[item]?.length > 50
              ? (element[item] | slice : 0 : 50) + "..."
              : element[item]
          }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'nmCobertura'">
        <td
          mat-cell
          *matCellDef="let element"
          #itemCol
          [matTooltip]="element[item]"
          [matTooltipDisabled]="element[item]?.length <= 50"
        >
          {{
            element[item]?.length > 50
              ? (element[item] | slice : 0 : 50) + "..."
              : element[item]
          }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'status'">
        <td
          mat-cell
          [ngClass]="
            element.status === true
              ? 'td__status__active pdcolumnmx'
              : 'td__status__deactivate pdcolumnmx'
          "
          *matCellDef="let element"
          #itemCol
        >
          {{ element.status === true ? "Ativo" : "Inativo" }}
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'cgg-tomador'">
        <td mat-cell *matCellDef="let element" class="pdcolumnmx">
          <ng-container *ngFor="let item of response.buttons">
            <button
              *ngIf="item.tooltip === 'Visualizar'"
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="item.tooltip === 'Editar'"
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="emitCheckCCG(item.page, element.id, item.pageParams)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="
                item.tooltip === 'Transmitir' &&
                element.segmentacaoSmall &&
                element.statusCCGId !== 2 &&
                element.statusCCGId !== 3 &&
                element.legalPersonId !== 0
              "
              mat-button
              [disabled]="item.disabled || !element.segmentacaoSmall"
              [matTooltip]="item.tooltip"
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="
                item.tooltip === 'Reenviar CCG' &&
                element.statusCCGId !== 1 &&
                element.namePerson !== null &&
                element.segmentacaoSmall
              "
              mat-button
              [disabled]="item.disabled || !element.segmentacaoSmall"
              [matTooltip]="item.tooltip"
              (click)="toTransmit(element.legalPersonId)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="item.tooltip === 'Imprimir-CCG' && element.printCCG"
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="printDocument(element.legalPersonId)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
          </ng-container>
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'user'">
        <td mat-cell *matCellDef="let element" class="pdcolumnmx">
          <ng-container *ngFor="let item of response.buttons">
            <button
              *ngIf="item.page !== '' && item.tooltip === 'Visualizar'"
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="goToNavigateUser(item.page, element.id, element)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="
                item.page !== '' &&
                item.tooltip === 'Editar' &&
                this.actions.includes('put')
              "
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="goToNavigateUser(item.page, element.id, element)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="item.page === ''"
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="resendPassword(element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
          </ng-container>
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'insuredActions'">
        <td mat-cell *matCellDef="let element" class="pdcolumnmx">
          <ng-container *ngFor="let item of response.buttons">
            <button
              *ngIf="item.tooltip === 'Visualizar'"
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="item.tooltip === 'Editar' && this.actions.includes('put')"
              mat-button
              [disabled]=""
              [matTooltip]="item.tooltip"
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
          </ng-container>
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'propostaAction'">
        <td mat-cell *matCellDef="let element" class="pdcolumnmx">
          <ng-container *ngFor="let item of response.buttons">
            <button
              *ngIf="
                item.tooltip === 'Editar' && element.proposalStatusId === 1
              "
              mat-button
              [disabled]="element.proposalStatusId >= 2"
              [matTooltip]="item.tooltip"
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="item.tooltip === 'Visualizar'"
              mat-button
              [matTooltip]="item.tooltip"
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
          </ng-container>
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'takerActions'">
        <td mat-cell *matCellDef="let element" class="pdcolumnmx">
          <ng-container *ngFor="let item of response.buttons">
            <button
              *ngIf="item.tooltip === 'Visualizar'"
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="item.tooltip === 'Editar' && this.actions.includes('put')"
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="emitCheckCCG(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="
                item.tooltip === 'Renovar Crédito' && element.isDataValidade
              "
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="actionButton(element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="item.tooltip === 'Atualizar Dados'"
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="secondActionButton(element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
          </ng-container>
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'proposalTable'">
        <td mat-cell *matCellDef="let element" class="pdcolumnmx">
          <ng-container *ngFor="let item of response.buttons">
            <!-- STATUS DA PROSPOSTA: Em Análise = 1, Em Negociação = 2, Emitida = 3  -->
            <button
              *ngIf="
                item.tooltip === 'Visualizar' &&
                !isProposalTypeJudicial(element.tp_proposta)
              "
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="emitValue(element, item.tooltip)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="
                item.tooltip === 'Editar' &&
                this.checkActionProposalPermission(
                  item.tooltip,
                  element.tp_proposta,
                  element.nm_status
                ) === true
              "
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="emitValue(element, item.tooltip)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="
                item.tooltip === 'Imprimir Minuta' &&
                this.checkActionProposalPermission(
                  item.tooltip,
                  element.tp_proposta,
                  element.nm_status
                ) === true
              "
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="imprimirMinuta(element, item.tooltip)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="
                item.tooltip === 'Emitir Apólice' &&
                this.checkActionProposalPermission(
                  item.tooltip,
                  element.tp_proposta,
                  element.nm_status
                ) === true
              "
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="emitirApolice(element, item.tooltip)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="
                item.tooltip === 'Imprimir Apólice' &&
                this.checkActionProposalPermission(
                  item.tooltip,
                  element.tp_proposta,
                  element.nm_status
                ) === true
              "
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="imprimirApolice(element, item.tooltip)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
          </ng-container>
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'commercialStructureActions'">
        <td mat-cell *matCellDef="let element" class="pdcolumnmx">
          <ng-container *ngFor="let item of response.buttons">
            <button
              *ngIf="item.tooltip === 'Visualizar'"
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="item.tooltip === 'Editar' && this.actions.includes('put')"
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="
                item.tooltip === 'Inativar-Parâmetro' &&
                element.status &&
                this.actions.includes('put')
              "
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="actionButton(element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
          </ng-container>
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'auditoriaActions'">
        <td mat-cell *matCellDef="let element" class="pdcolumnmx">
          <ng-container *ngFor="let item of response.buttons">
            <button
              *ngIf="item.tooltip === 'Mais Detalhes'"
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
          </ng-container>
        </td>
      </ng-container>

      <ng-container *ngIf="item === 'actions'">
        <td mat-cell *matCellDef="let element" class="pdcolumnmx">
          <ng-container *ngFor="let item of response.buttons">
            <button
              *ngIf="item.tooltip === 'Visualizar'"
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="item.tooltip === 'Editar' && this.actions.includes('put')"
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="goToNavigate(item.page, element.id)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="
                item.tooltip === 'Inativar Parâmetro' &&
                this.actions.includes('put') &&
                item.page === 'clause' &&
                element.status
              "
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="inativarParametroClausulas(element)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="
                item.tooltip === 'Inativar Parâmetro' &&
                item.page === 'liberacao-proposta-tomador' &&
                element.status &&
                this.actions.includes('put')
              "
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="inativarParametroLiberacaoPropostaTomador(element)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
            <button
              *ngIf="
                item.tooltip === 'Inativar Parâmetro' &&
                this.actions.includes('put') &&
                item.page === 'average' &&
                element.status
              "
              mat-button
              [disabled]="item.disabled"
              [matTooltip]="item.tooltip"
              (click)="inativarParametroTaxaMix(element)"
            >
              <img src="../../../assets/icons/{{ item.icon }}.svg" />
            </button>
          </ng-container>
        </td>
      </ng-container>
    </ng-container>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="response.displayedReference"></tr>
  <tr mat-row *matRowDef="let row; columns: response.displayedReference"></tr>
</table>
